import React from 'react';

const BranchRenderer = ({ rowData: { summarized, branchId }, columnData: { mappedBranches } }) => {
  if (summarized || !branchId) {
    return <></>;
  }

  return <>{mappedBranches?.[branchId]?.name || ''}</>;
};

export default BranchRenderer;
